import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findSmartLockPermissionsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/smart-lock-permissions?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch smart lock permissions');

    return response.json();
}

export async function createSmartLockPermission(customerId) {
    if (!customerId) {
        throw new Error("The customerId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/smart-lock-permissions`, {
        method  : 'POST',
        body    : JSON.stringify({
            customerId : customerId
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create smart lock permission');
}

export async function deleteSmartLockPermission(customerId) {
    if (!customerId) {
        throw new Error("The customerId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/smart-lock-permissions/${customerId}`, {
        method  : 'DELETE',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to delete smart lock permission');
}
